import { Column } from "@components/Layout";
import { Image, Button as KButton } from "@kobalte/core";
import { styled } from "solid-styled-components";

export const TracklistImage = styled(Image.Root)`
    border-radius: 16px;
    aspect-ratio: 1 / 2;
    width: 100%;
    max-width: 220px;
    max-height: 233px;
    overflow: hidden;
    flex-shrink: 0;
    box-shadow: 0 0 15px #00000060;
    cursor: pointer;
    & > *{
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
    }
`;

export const MobileHeaderColumn = styled(Column)`
    @media only screen and (min-width: 513px){
        display: none;
    }
`;
export const SignInButton = styled(KButton.Root)`
    cursor: pointer;
    border-radius: 19px;
    background: #e1e1e3;
    color: #5a5a5c;
    height: 46px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    font-size: 15px;
    font-weight: 600;
    padding: 0 20px;
    & > img{
        height: 20px;
    }
`;

export const MobilePlayButton = styled.div`
 .altPlayer{
    color: white !important;
    aspect-ratio: unset;
    width: max-content;
    border-radius: 20px;
    padding: 0 20px;
    height: 45px;
 }
`;
